export default [
    {
        dataName: "totalPO",
        label: "PO Created",
        icon: "ThumbsUpIcon",
        type: "statisticsiconright",
        value: ""
    },  
    {
        dataName: "totalAmountPO",
        label: "Total Amount",
        icon: "ThumbsUpIcon",
        type: "statisticsiconright",
        value: ""
    },  
   
  
    {
        dataName: "pendingPO",
        label: "Pending PO",
        icon: "FilterIcon",
        type: "statistics",
        value: ""
    },
  
    {
        dataName: "totalRejectedPO",
        label: "Rejected PO",
        icon: "ThumbsDownIcon",
        type: "statistics",
        value: ""
    },
  
    {
        dataName: "totalApprovedPO",
        label: "Approved PO",
        icon: "ThumbsDownIcon",
        type: "statistics",
        value: ""
    },
  
    {
        dataName: "totalPendingPOAmount",
        label: "Pending Amount",
        icon: "FilterIcon",
        type: "statistics",
        value: ""
    },
  
    {
        dataName: "totalRejectedPOAmount",
        label: "Reject Amount",
        icon: "ThumbsUpIcon",
        type: "statistics",
        value: ""
    },
    {
        dataName: "totalApprovedPOAmount",
        label: "Approved Amount",
        icon: "ThumbsDownIcon",
        type: "statistics",
        value: ""
    },

    {
        dataName: "totalCLOSEDAmount",
        label: "Total Closed PO Amount",
        icon: "ThumbsUpIcon",
        type: "statisticsiconright",
        value: ""
    }, 

    {
        dataName: "totalCLOSED",
        label: "Total Closed PO",
        icon: "ThumbsDownIcon",
        type: "statistics",
        value: ""
    },
  
  
]